import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=33370aac&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"
import style0 from "./Download.vue?vue&type=style&index=0&id=33370aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33370aac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRichtext: require('/app/components/base/Richtext.vue').default,BaseLinkApp: require('/app/components/base/LinkApp.vue').default,BaseQrSmart: require('/app/components/base/QrSmart.vue').default})
